import { backend_client } from "../../../helpers/api";

const getPendingExamsReportService = () => {
  return backend_client.get("/exam-instances/pending-exams-report", {
    responseType: "blob",
  });
};

export default getPendingExamsReportService;
